export default function Popover(theme: any) {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          "& .MuiMenu-list": {
            backgroundColor: theme.palette.grey[700],
            color: "white",
            borderRadius: 1,
          },
          "& .MuiMenu-list .Mui-selected, & .Mui-focusVisible": {
            backgroundColor: "transparent",
          },
          "& .MuiMenu-list .MuiMenuItem-root.MuiMenuItem-root ": {
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
        },
      },
    },
  };
}
